import {
	createSummaryTo,
	SummaryCardSection,
	SummaryField,
	SummaryFieldGroup,
} from "@portal/components/multiform";
import { RichTextDisplay } from "@portal/components/ui/RichTextDisplay";
import { useLocation } from "react-router-dom";
import { formatEmpty } from "../../../utils";

type AdditionalInfoSummaryProps = {
	comment?: string | null;
	attachments?: Array<{ name: string; extension: string }>;
	commentFieldPath: string;
	attachmentsFieldPath: string;
	header?: string;
	commentLabel?: string;
	section?: string;
};

export const AdditionalInfoSummary = ({
	comment,
	attachments,
	commentFieldPath,
	attachmentsFieldPath,
	header = "Additional Info",
	commentLabel = "Submission Narrative",
	section = "additionalInfo",
}: AdditionalInfoSummaryProps) => {
	const { pathname } = useLocation();
	const to = createSummaryTo(pathname, section);

	return (
		<SummaryCardSection header={header} to={{ pathname, section }}>
			<SummaryFieldGroup>
				<SummaryField
					label={commentLabel}
					vertical
					value={
						comment ? (
							<div className="line-clamp-3">
								<RichTextDisplay content={comment} />
							</div>
						) : (
							formatEmpty(comment)
						)
					}
					fieldPath={commentFieldPath}
					to={to(commentFieldPath)}
				/>
				<SummaryField
					label="Attachments"
					vertical
					value={
						(attachments?.length ?? 0) > 0
							? attachments!.map((a) => `${a.name}.${a.extension}`)
							: formatEmpty(undefined)
					}
					fieldPath={attachmentsFieldPath}
					to={to(attachmentsFieldPath)}
				/>
			</SummaryFieldGroup>
		</SummaryCardSection>
	);
};
